<template>
  <div class="blaze">
    <logo />
    <fonction />
    <mail />
    <social />
  </div>
</template>
<script>
import Logo from "@/components/Identity/Logo";
import Fonction from "@/components/Identity/Fonction";
import Mail from "@/components/Identity/Mail";
import Social from "@/components/Identity/Social";
export default {
  data() {
    return {};
  },
  components: {
    Logo,
    Fonction,
    Mail,
    Social
  },
  computed: {},
  methods: {},
  watch: {},
  mounted() {}
};
</script>
<style>
@import "~@/assets/styles/blaze.less";
</style>
